//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
        }
}

export class ChatRoom extends BaseEntity {
    gestitoDa : string;
    disabled : boolean;
    title : string;
    ticketNumber : string;
    nomeCliente : string;
    clienteIdentifier : string;
    assignedToUser : string;
    hasNewMessages : boolean;
    deviceId : string;
    description : string;
    imgUrl : string;
    subscribers : string[];
    messages : ChatMessage[];
    lastMessage : ChatMessage;

    constructor() 
    {
    	        super();
		            this.gestitoDa = "" ;
                this.disabled = false ;
                this.title = "" ;
                this.ticketNumber = "" ;
                this.nomeCliente = "" ;
                this.clienteIdentifier = "" ;
                this.assignedToUser = "" ;
                this.hasNewMessages = false ;
                this.deviceId = "" ;
                this.description = "" ;
                this.imgUrl = "" ;
                this.subscribers = [];
                this.messages = [];
                this.lastMessage = new ChatMessage();
        }
}

export class ChatMessage {
    identifier : string;
    timestamp : number;
    sender : string;
    senderIdentifier : string;
    text : string;
    fromBackend : boolean;
    quotedMessage : QuotedMessage;

    constructor() 
    {
    	            this.identifier = "" ;
                this.timestamp = null ;
                this.sender = "" ;
                this.senderIdentifier = "" ;
                this.text = "" ;
                this.fromBackend = false ;
                this.quotedMessage = new QuotedMessage();
        }
}

export class QuotedMessage {
    sender : string;
    text : string;
    fromBackend : boolean;

    constructor() 
    {
    	            this.sender = "" ;
                this.text = "" ;
                this.fromBackend = false ;
        }
}

export class ChatRoomVm {
    disabled : boolean;
    identifier : string;
    title : string;
    ticketNumber : string;
    imgUrl : string;
    description : string;
    subscribersCount : number;
    isSubscribed : boolean;
    clienteIdentifier : string;
    assignedToUser : string;
    messagesCount : number;

    constructor() 
    {
    	            this.disabled = false ;
                this.identifier = "" ;
                this.title = "" ;
                this.ticketNumber = "" ;
                this.imgUrl = "" ;
                this.description = "" ;
                this.subscribersCount = null ;
                this.isSubscribed = false ;
                this.clienteIdentifier = "" ;
                this.assignedToUser = "" ;
                this.messagesCount = null ;
        }
}

export class RemoveChatMessagesVm {
    chatRoomIdentifier : string;
    messagesIdentifier : string[];

    constructor() 
    {
    	            this.chatRoomIdentifier = "" ;
                this.messagesIdentifier = [];
        }
}

export class SaveHelpTicketVm {
    nomeCliente : string;
    project : string;
    clienteIdentifier : string;
    subject : string;
    text : string;
    timeStamp : number;
    assignToUser : string;

    constructor() 
    {
    	            this.nomeCliente = "" ;
                this.project = "" ;
                this.clienteIdentifier = "" ;
                this.subject = "" ;
                this.text = "" ;
                this.timeStamp = null ;
                this.assignToUser = "" ;
        }
}

export class TablePagedResultOfHelpTicketVm {
    data : HelpTicketVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class HelpTicketVm {
    gestitoDa : string;
    createdOn : string ;
    identifier : string;
    disabled : boolean;
    subject : string;
    nomeCliente : string;
    clienteIdentifier : string;
    ticketNumber : string;
    hasNewMessages : boolean;
    fromBackend : boolean;
    assignedToUser : string;

    constructor() 
    {
    	            this.gestitoDa = "" ;
                this.createdOn = null;
                this.identifier = "" ;
                this.disabled = false ;
                this.subject = "" ;
                this.nomeCliente = "" ;
                this.clienteIdentifier = "" ;
                this.ticketNumber = "" ;
                this.hasNewMessages = false ;
                this.fromBackend = false ;
                this.assignedToUser = "" ;
        }
}

export class BasePagedRequest {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.sortBy = new SortByParameter();
        }
}

export class TicketListFilterVm extends BasePagedRequest {
    createdOn : string ;
    stillOpenOnly : boolean;
    nomeCliente : string;
    subject : string;
    ticketNumber : string;
    gestitoDa : string;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.stillOpenOnly = false ;
                this.nomeCliente = "" ;
                this.subject = "" ;
                this.ticketNumber = "" ;
                this.gestitoDa = "" ;
        }
}

export class SortByParameter {
    propertyName : string;
    ascending : boolean;

    constructor() 
    {
    	            this.propertyName = "" ;
                this.ascending = false ;
        }
}

export class GetOrariAperturaTicketVm {
    text : LocalizedValue;
    canOpen : boolean;

    constructor() 
    {
    	            this.text = new LocalizedValue();
                this.canOpen = false ;
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class NameIdentifier {
    identifier : string;
    name : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
        }
}

export class NetworkUserVm {
    createdOn : string ;
    completeName : string;
    imageUrl : string;
    referralCode : string;
    role : string;
    type : string;
    qualification : Qualification;
    identifier : string;

    constructor() 
    {
    	            this.createdOn = null;
                this.completeName = "" ;
                this.imageUrl = "" ;
                this.referralCode = "" ;
                this.role = "" ;
                this.type = "" ;
                this.qualification = new Qualification();
                this.identifier = "" ;
        }
}

export class Qualification {
    date : string ;
    qualificationCode : string;

    constructor() 
    {
    	            this.date = null;
                this.qualificationCode = "" ;
        }
}

export class TablePagedResultOfBaseBackendNotification {
    data : BaseBackendNotification[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BaseBackendNotification extends BaseEntity {
    user : NameIdentifier;
    readOn : string ;
    text : string;
    type : string;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.readOn = null;
                this.text = "" ;
                this.type = "" ;
        }
}

export class BackendRoleConfig extends BaseEntity {
    name : string;
    isDefault : boolean;
    defaultProject : string;
    clientModules : string[];
    permissions : RoleConfigPermissions[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.isDefault = false ;
                this.defaultProject = "" ;
                this.clientModules = [];
                this.permissions = [];
        }
}

export class RoleConfigPermissions {
    backendModule : string;
    createUpdate : boolean;
    read : boolean;
    delete : boolean;

    constructor() 
    {
    	            this.backendModule = "" ;
                this.createUpdate = false ;
                this.read = false ;
                this.delete = false ;
        }
}

export class TablePagedResultOfCard {
    data : Card[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class Card extends BaseEntity {
    nameOnCard : string;
    cardNumber : string;
    cvv : string;
    wallesterAccountId : string;
    wallesterCardId : string;
    expiresOn : string ;
    user : NameIdentifier;
    fixedBalanceToAdd : number;

    constructor() 
    {
    	        super();
		            this.nameOnCard = "" ;
                this.cardNumber = "" ;
                this.cvv = "" ;
                this.wallesterAccountId = "" ;
                this.wallesterCardId = "" ;
                this.expiresOn = null;
                this.user = new NameIdentifier();
                this.fixedBalanceToAdd = null ;
        }
}

export class CardListFilterVm extends BasePagedRequest {
    createdOnFrom : string ;
    createdOnTo : string ;
    cardNumber : string;
    wallesterAccountId : string;
    wallesterCardId : string;
    expiresOnFrom : string ;
    expiresOnTo : string ;
    user : string;

    constructor() 
    {
    	        super();
		            this.createdOnFrom = null;
                this.createdOnTo = null;
                this.cardNumber = "" ;
                this.wallesterAccountId = "" ;
                this.wallesterCardId = "" ;
                this.expiresOnFrom = null;
                this.expiresOnTo = null;
                this.user = "" ;
        }
}

export class Transaction {
    account_amount : number;
    account_currency_code : string;
    acquirer_business_id : string;
    acquirer_reference_number : string;
    authorization_code : string;
    authorization_id : string;
    card_id : string;
    central_processing_date : string ;
    created_at : string ;
    exchange_rate : number;
    group : string;
    has_payment_document_files : boolean;
    has_payment_notes : boolean;
    id : string;
    is_failed : boolean;
    marked_for_dispute_at : string ;
    marked_for_dispute_by : string;
    merchant_category_code : string;
    merchant_city : string;
    merchant_country_code : string;
    merchant_id : string;
    merchant_name : string;
    merchant_postal_code : string;
    processed_at : string ;
    purchase_date : string ;
    terminal_id : string;
    total_amount : number;
    transaction_amount : number;
    transaction_code : string;
    transaction_currency_code : string;
    transaction_identifier : string;

    constructor() 
    {
    	            this.account_amount = null ;
                this.account_currency_code = "" ;
                this.acquirer_business_id = "" ;
                this.acquirer_reference_number = "" ;
                this.authorization_code = "" ;
                this.authorization_id = "" ;
                this.card_id = "" ;
                this.central_processing_date = null;
                this.created_at = null;
                this.exchange_rate = null ;
                this.group = "" ;
                this.has_payment_document_files = false ;
                this.has_payment_notes = false ;
                this.id = "" ;
                this.is_failed = false ;
                this.marked_for_dispute_at = null;
                this.marked_for_dispute_by = "" ;
                this.merchant_category_code = "" ;
                this.merchant_city = "" ;
                this.merchant_country_code = "" ;
                this.merchant_id = "" ;
                this.merchant_name = "" ;
                this.merchant_postal_code = "" ;
                this.processed_at = null;
                this.purchase_date = null;
                this.terminal_id = "" ;
                this.total_amount = null ;
                this.transaction_amount = null ;
                this.transaction_code = "" ;
                this.transaction_currency_code = "" ;
                this.transaction_identifier = "" ;
        }
}

export class TablePagedResultOfBaseCommission {
    data : BaseCommission[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BaseCommission extends BaseEntity {
    type : string;
    customer : NameIdentifier;
    user : NameIdentifier;
    upliner : NameIdentifier;
    userQualification : Qualification;
    uplinerQualification : Qualification;
    points : number;
    paidAmount : number;
    paidOn : string ;

    constructor() 
    {
    	        super();
		            this.type = "" ;
                this.customer = new NameIdentifier();
                this.user = new NameIdentifier();
                this.upliner = new NameIdentifier();
                this.userQualification = new Qualification();
                this.uplinerQualification = new Qualification();
                this.points = null ;
                this.paidAmount = null ;
                this.paidOn = null;
        }
}

export class CommissionsByUplinerIdentifierListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    showZeroLines : boolean;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.showZeroLines = false ;
        }
}

export class ProvvigioniListFilterVm extends BasePagedRequest {
    category : string;
    commissionType : string;
    createdOn : string ;
    createdFrom : string ;
    createdTo : string ;
    modifiedOn : string ;
    customer : string;
    user : string;
    rebateRowId : string;
    performanceRowId : string;
    parent : string;
    userQualification : string;
    parentQualification : string;
    points : number;
    paidAmount : number;
    showZeroLines : boolean;

    constructor() 
    {
    	        super();
		            this.category = "" ;
                this.commissionType = "" ;
                this.createdOn = null;
                this.createdFrom = null;
                this.createdTo = null;
                this.modifiedOn = null;
                this.customer = "" ;
                this.user = "" ;
                this.rebateRowId = "" ;
                this.performanceRowId = "" ;
                this.parent = "" ;
                this.userQualification = "" ;
                this.parentQualification = "" ;
                this.points = null ;
                this.paidAmount = null ;
                this.showZeroLines = false ;
        }
}

export class DashboardPortafoglioVm {
    richiestaPagamento : UserPaymentRequest;
    balance : number;
    total : number;
    waiting : number;
    withdrawed : number;

    constructor() 
    {
    	            this.richiestaPagamento = new UserPaymentRequest();
                this.balance = null ;
                this.total = null ;
                this.waiting = null ;
                this.withdrawed = null ;
        }
}

export class UserPaymentRequest extends BaseEntity {
    user : NameIdentifier;
    importo : number;
    commissioneTrattenuta : number;
    dataRicevuta : string ;
    allegato : Attachment;
    useRitenutaAcconto : boolean;
    datiRitenutaAcconto : DatiRitenutaAcconto;
    gestitaOn : string ;
    userPaymentReceiptIdentifier : string;
    charityAmount : number;
    paymentData : UserPaymentData;
    personalData : PersonalData;
    fiscalData : FiscalData;
    contactData : ContactData;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.importo = null ;
                this.commissioneTrattenuta = null ;
                this.dataRicevuta = null;
                this.allegato = new Attachment();
                this.useRitenutaAcconto = false ;
                this.datiRitenutaAcconto = new DatiRitenutaAcconto();
                this.gestitaOn = null;
                this.userPaymentReceiptIdentifier = "" ;
                this.charityAmount = null ;
                this.paymentData = new UserPaymentData();
                this.personalData = new PersonalData();
                this.fiscalData = new FiscalData();
                this.contactData = new ContactData();
        }
}

export class Attachment {
    fileIdentifier : string;
    fileName : string;
    mimeType : string;
    lastModifiedOn : string ;
    publicUrl : string;
    region : string;
    bucket : string;
    subDir : string;

    constructor() 
    {
    	            this.fileIdentifier = "" ;
                this.fileName = "" ;
                this.mimeType = "" ;
                this.lastModifiedOn = null;
                this.publicUrl = "" ;
                this.region = "" ;
                this.bucket = "" ;
                this.subDir = "" ;
        }
}

export class DatiRitenutaAcconto {
    dataRitenuta : string;
    nomeUtente : string;
    luogoNascita : string;
    indirizzoResidenza : string;
    fiscalCode : string;
    iban : string;
    intestatarioConto : string;
    importoLordo : string;
    importoRitenuta : string;
    importoNetto : string;

    constructor() 
    {
    	            this.dataRitenuta = "" ;
                this.nomeUtente = "" ;
                this.luogoNascita = "" ;
                this.indirizzoResidenza = "" ;
                this.fiscalCode = "" ;
                this.iban = "" ;
                this.intestatarioConto = "" ;
                this.importoLordo = "" ;
                this.importoRitenuta = "" ;
                this.importoNetto = "" ;
        }
}

export class UserPaymentData {
    bankAccountData : BankAccountData;
    paypalEmail : string;
    revolutNumber : string;
    modalitaPagamento : string;
    cryptoAddress : string;

    constructor() 
    {
    	            this.bankAccountData = new BankAccountData();
                this.paypalEmail = "" ;
                this.revolutNumber = "" ;
                this.modalitaPagamento = "" ;
                this.cryptoAddress = "" ;
        }
}

export class BankAccountData {
    intestatario : string;
    bankName : string;
    iban : string;
    swift : string;

    constructor() 
    {
    	            this.intestatario = "" ;
                this.bankName = "" ;
                this.iban = "" ;
                this.swift = "" ;
        }
}

export class PersonalData {
    name : string;
    surname : string;
    profilePicture : string;
    completeName : string;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.profilePicture = "" ;
                this.completeName = "" ;
        }
}

export class FiscalData {
    name : string;
    surname : string;
    sex : string;
    dataNascita : string ;
    luogoNascita : string;
    fiscalCode : string;
    hasVat : boolean;
    companyName : string;
    vatNumber : string;
    codiceDestinatario : string;
    pec : string;
    fiscalAddress : Address;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.sex = "" ;
                this.dataNascita = null;
                this.luogoNascita = "" ;
                this.fiscalCode = "" ;
                this.hasVat = false ;
                this.companyName = "" ;
                this.vatNumber = "" ;
                this.codiceDestinatario = "" ;
                this.pec = "" ;
                this.fiscalAddress = new Address();
        }
}

export class Address {
    typedAddress : string;
    citta : string;
    provincia : string;
    cap : string;
    scalaPianoInterno : string;
    via : string;
    civico : string;
    note : string;
    nazione : string;
    regione : string;
    latLong : LatLong;
    completeAddress : string;

    constructor() 
    {
    	            this.typedAddress = "" ;
                this.citta = "" ;
                this.provincia = "" ;
                this.cap = "" ;
                this.scalaPianoInterno = "" ;
                this.via = "" ;
                this.civico = "" ;
                this.note = "" ;
                this.nazione = "" ;
                this.regione = "" ;
                this.latLong = new LatLong();
                this.completeAddress = "" ;
        }
}

export class LatLong {
    lat : number;
    long : number;

    constructor() 
    {
    	            this.lat = null ;
                this.long = null ;
        }
}

export class ContactData {
    contactName : string;
    email : string;
    telephone : Telephone;
    address : Address;

    constructor() 
    {
    	            this.contactName = "" ;
                this.email = "" ;
                this.telephone = new Telephone();
                this.address = new Address();
        }
}

export class Telephone {
    prefix : string;
    number : string;
    completeNumber : string;

    constructor() 
    {
    	            this.prefix = "" ;
                this.number = "" ;
                this.completeNumber = "" ;
        }
}

export class PerformanceChartValuesVm {
    values : DateValueOfDecimal[];
    networkValues : DateValueOfDecimal[];
    personali : number;
    network : number;

    constructor() 
    {
    	            this.values = [];
                this.networkValues = [];
                this.personali = null ;
                this.network = null ;
        }
}

export class DateValueOfDecimal {
    date : string ;
    value : number;

    constructor() 
    {
    	            this.date = null;
                this.value = null ;
        }
}

export class ContatoreAttiviVm {
    total : number;
    actives : number;
    qualifications : QualificationCounterVm[];

    constructor() 
    {
    	            this.total = null ;
                this.actives = null ;
                this.qualifications = [];
        }
}

export class QualificationCounterVm {
    qualificationCode : string;
    count : number;

    constructor() 
    {
    	            this.qualificationCode = "" ;
                this.count = null ;
        }
}

export class DashboardProfileVm {
    identifier : string;
    name : string;
    referralCode : string;
    imageUrl : string;
    saldo : number;
    qualificationCode : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.referralCode = "" ;
                this.imageUrl = "" ;
                this.saldo = null ;
                this.qualificationCode = "" ;
        }
}

export class GuadagniChartValuesVm {
    obiettivoMensile : number;
    values : DateValueOfDecimal[];

    constructor() 
    {
    	            this.obiettivoMensile = null ;
                this.values = [];
        }
}

export class VenditoreBestVm {
    name : string;
    vendite : number;
    fatturato : number;

    constructor() 
    {
    	            this.name = "" ;
                this.vendite = null ;
                this.fatturato = null ;
        }
}

export class UserPaymentReceipt extends BaseEntity {
    user : NameIdentifier;
    receiverUser : NameIdentifier;
    date : string ;
    euroAmount : number;
    charityAmount : number;
    receiptNumber : string;
    note : string;
    isBonus : boolean;
    userPaymentRequestIdentifier : string;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.receiverUser = new NameIdentifier();
                this.date = null;
                this.euroAmount = null ;
                this.charityAmount = null ;
                this.receiptNumber = "" ;
                this.note = "" ;
                this.isBonus = false ;
                this.userPaymentRequestIdentifier = "" ;
        }
}

export class UserCardVm {
    identifier : string;
    imageUrl : string;
    name : string;
    earned : number;
    waiting : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.imageUrl = "" ;
                this.name = "" ;
                this.earned = null ;
                this.waiting = null ;
        }
}

export class UserObiettivoCardVm {
    identifier : string;
    imageUrl : string;
    name : string;
    obiettivo : number;
    risultato : number;
    fatturato : number;
    saldo : number;
    qualificationCode : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.imageUrl = "" ;
                this.name = "" ;
                this.obiettivo = null ;
                this.risultato = null ;
                this.fatturato = null ;
                this.saldo = null ;
                this.qualificationCode = "" ;
        }
}

export class DashboardDocument extends BaseEntity {
    name : string;
    description : string;
    url : string;
    attachment : Attachment;
    folder : string;
    userRead : DateValueOfNameIdentifier[];
    visibleBy : string[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.description = "" ;
                this.url = "" ;
                this.attachment = new Attachment();
                this.folder = "" ;
                this.userRead = [];
                this.visibleBy = [];
        }
}

export class DateValueOfNameIdentifier {
    date : string ;
    value : NameIdentifier;

    constructor() 
    {
    	            this.date = null;
                this.value = new NameIdentifier();
        }
}

export class GetFoldersResponseVm {
    name : string;
    hasNew : boolean;

    constructor() 
    {
    	            this.name = "" ;
                this.hasNew = false ;
        }
}

export class DeferredPayment extends BaseEntity {
    amount : number;
    currencyCode : string;
    currencySymbol : string;
    customer : NameIdentifier;
    confirmedOn : string ;
    comments : Comment[];
    internalComments : Comment[];
    canceledOn : string ;
    method : string;
    type : string;

    constructor() 
    {
    	        super();
		            this.amount = null ;
                this.currencyCode = "" ;
                this.currencySymbol = "" ;
                this.customer = new NameIdentifier();
                this.confirmedOn = null;
                this.comments = [];
                this.internalComments = [];
                this.canceledOn = null;
                this.method = "" ;
                this.type = "" ;
        }
}

export class Comment {
    identifier : string;
    createdOn : string ;
    author : NameIdentifier;
    text : string;
    attachments : Attachment[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.author = new NameIdentifier();
                this.text = "" ;
                this.attachments = [];
        }
}

export class CreateDeferredPaymentFromCartVm {
    method : string;
    cart : ShoppingCart;

    constructor() 
    {
    	            this.method = "" ;
                this.cart = new ShoppingCart();
        }
}

export class ShoppingCart extends BaseEntity {
    customer : NameIdentifier;
    offers : OfferQuantityPair[];
    formAnswers : { [key: string]: string[]; };
    isPending : boolean;

    constructor() 
    {
    	        super();
		            this.customer = new NameIdentifier();
                this.offers = [];
                this.formAnswers = {};
                this.isPending = false ;
        }
}

export class OfferQuantityPair {
    offer : NameIdentifier;
    quantity : number;

    constructor() 
    {
    	            this.offer = new NameIdentifier();
                this.quantity = null ;
        }
}

export class CardTopUp extends DeferredPayment {
    cardNumber : string;

    constructor() 
    {
    	        super();
		            this.cardNumber = "" ;
        }
}

export class CreateCardTopUpVm {
    customer : NameIdentifier;
    cardNumber : string;
    amount : number;
    project : string;
    country : string;
    paymentMethod : string;

    constructor() 
    {
    	            this.customer = new NameIdentifier();
                this.cardNumber = "" ;
                this.amount = null ;
                this.project = "" ;
                this.country = "" ;
                this.paymentMethod = "" ;
        }
}

export class TablePagedResultOfDeferredPayment {
    data : DeferredPayment[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PagamentoBonificoListFilterVm extends BasePagedRequest {
    fromDate : string ;
    toDate : string ;
    type : string;
    customer : string;
    offers : string;
    amount : string;
    canceled : boolean;
    approvedFromDate : string ;
    approvedToDate : string ;
    documentoCaricato : boolean;

    constructor() 
    {
    	        super();
		            this.fromDate = null;
                this.toDate = null;
                this.type = "" ;
                this.customer = "" ;
                this.offers = "" ;
                this.amount = "" ;
                this.canceled = false ;
                this.approvedFromDate = null;
                this.approvedToDate = null;
                this.documentoCaricato = false ;
        }
}

export class FaqNode extends BaseEntity {
    isRoot : boolean;
    nodeText : LocalizedValue;
    answersList : FaqNodeText[];

    constructor() 
    {
    	        super();
		            this.isRoot = false ;
                this.nodeText = new LocalizedValue();
                this.answersList = [];
        }
}

export class FaqNodeText {
    identifier : string;
    name : LocalizedValue;
    order : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = new LocalizedValue();
                this.order = null ;
        }
}

export class GlobalConfig extends BaseEntity {
    globalAwsRegion : string;
    globalAwsBucket : string;

    constructor() 
    {
    	        super();
		            this.globalAwsRegion = "" ;
                this.globalAwsBucket = "" ;
        }
}

export class InAppNotification extends BaseEntity {
    user : NameIdentifier;
    readOn : string ;
    text : string;
    type : string;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.readOn = null;
                this.text = "" ;
                this.type = "" ;
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class LoginData {
    userIdentifier : string;
    token : string;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.token = "" ;
        }
}

export class LoginVm {
    username : string;
    password : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
        }
}

export class RegisterVm {
    name : string;
    surname : string;
    email : string;
    password : string;
    referralCode : string;
    project : string;
    country : string;
    nomeCentro : string;
    telephone : Telephone;
    skipConfirmationMail : boolean;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.password = "" ;
                this.referralCode = "" ;
                this.project = "" ;
                this.country = "" ;
                this.nomeCentro = "" ;
                this.telephone = new Telephone();
                this.skipConfirmationMail = false ;
        }
}

export class MailEventDefinition {
    eventName : string;
    variables : string[];

    constructor() 
    {
    	            this.eventName = "" ;
                this.variables = [];
        }
}

export class TablePagedResultOfMailSentLog {
    data : MailSentLog[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class MailSentLog extends BaseEntity {
    mailEvent : string;
    variables : string;
    recipients : string[];
    ccs : string[];
    bccs : string[];

    constructor() 
    {
    	        super();
		            this.mailEvent = "" ;
                this.variables = "" ;
                this.recipients = [];
                this.ccs = [];
                this.bccs = [];
        }
}

export class MailSentLogListFilterVm extends BasePagedRequest {
    createdOn : string ;
    mailEvent : string;
    variables : string;
    recipients : string;
    ccs : string;
    bccs : string;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.mailEvent = "" ;
                this.variables = "" ;
                this.recipients = "" ;
                this.ccs = "" ;
                this.bccs = "" ;
        }
}

export class Membership extends BaseEntity {
    number : string;
    user : NameIdentifier;
    startFrom : string ;
    expiresOn : string ;
    purchasesIdentifier : string[];
    contracts : Attachment[];
    contractSignedOn : string ;
    generatedOtpForSigning : string;

    constructor() 
    {
    	        super();
		            this.number = "" ;
                this.user = new NameIdentifier();
                this.startFrom = null;
                this.expiresOn = null;
                this.purchasesIdentifier = [];
                this.contracts = [];
                this.contractSignedOn = null;
                this.generatedOtpForSigning = "" ;
        }
}

export class MessageOfTheDay extends BaseEntity {
    message : string;
    author : string;
    dayNumber : number;
    monthNumber : number;

    constructor() 
    {
    	        super();
		            this.message = "" ;
                this.author = "" ;
                this.dayNumber = null ;
                this.monthNumber = null ;
        }
}

export class NewsFeedItem extends BaseEntity {
    publishedOn : string ;
    title : LocalizedValue;
    htmlText : LocalizedValue;
    courseContents : CourseContent[];

    constructor() 
    {
    	        super();
		            this.publishedOn = null;
                this.title = new LocalizedValue();
                this.htmlText = new LocalizedValue();
                this.courseContents = [];
        }
}

export class CourseContent {
    title : LocalizedValue;
    subTitle : LocalizedValue;
    url : LocalizedValue;
    textContent : LocalizedValue;

    constructor() 
    {
    	            this.title = new LocalizedValue();
                this.subTitle = new LocalizedValue();
                this.url = new LocalizedValue();
                this.textContent = new LocalizedValue();
        }
}

export class NewsFeedItemListVm {
    identifier : string;
    publishedOn : string ;
    title : string;
    excerpt : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.publishedOn = null;
                this.title = "" ;
                this.excerpt = "" ;
        }
}

export class PdfInterpolationTemplate extends BaseEntity {
    name : string;
    documentType : string;
    originalPdf : Attachment;
    pageScreenshots : Attachment[];
    pageWidth : number;
    pageHeight : number;
    stickDataConfigs : BaseStickDataConfig[];
    isActive : boolean;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.documentType = "" ;
                this.originalPdf = new Attachment();
                this.pageScreenshots = [];
                this.pageWidth = null ;
                this.pageHeight = null ;
                this.stickDataConfigs = [];
                this.isActive = false ;
        }
}

export abstract class BaseStickDataConfig {
    x : number;
    y : number;
    pageNumber : number;
    type : string;

    constructor() 
    {
    	            this.x = null ;
                this.y = null ;
                this.pageNumber = null ;
                this.type = "" ;
        }
}

export class TextDataConfig extends BaseStickDataConfig {
    text : string;
    fontSize : number;
    fontFamily : string;
    color : string;
    fontWeight : string;
    textAlign : string;

    constructor() 
    {
    	        super();
		            this.text = "" ;
                this.fontSize = null ;
                this.fontFamily = "" ;
                this.color = "" ;
                this.fontWeight = "" ;
                this.textAlign = "" ;
        }
}

export class ImageDataConfig extends BaseStickDataConfig {
    image : Attachment;
    objectFit : string;
    width : number;
    height : number;

    constructor() 
    {
    	        super();
		            this.image = new Attachment();
                this.objectFit = "" ;
                this.width = null ;
                this.height = null ;
        }
}

export class DocumentFieldConfig extends BaseStickDataConfig {
    fieldName : string;
    fontSize : number;
    fontFamily : string;
    color : string;
    fontWeight : string;
    textAlign : string;

    constructor() 
    {
    	        super();
		            this.fieldName = "" ;
                this.fontSize = null ;
                this.fontFamily = "" ;
                this.color = "" ;
                this.fontWeight = "" ;
                this.textAlign = "" ;
        }
}

export class ProjectConfigVm {
    name : string;
    logoUrl : string;
    siteUrl : string;
    modules : FrontendModuleConfig[];
    dashboardModules : string[];
    colors : ProjectColors;

    constructor() 
    {
    	            this.name = "" ;
                this.logoUrl = "" ;
                this.siteUrl = "" ;
                this.modules = [];
                this.dashboardModules = [];
                this.colors = new ProjectColors();
        }
}

export class FrontendModuleConfig {
    name : string;
    order : number;
    isCustom : boolean;
    customName : string;
    customUrl : string;
    isTargetBlank : boolean;

    constructor() 
    {
    	            this.name = "" ;
                this.order = null ;
                this.isCustom = false ;
                this.customName = "" ;
                this.customUrl = "" ;
                this.isTargetBlank = false ;
        }
}

export class ProjectColors {
    primary : string;
    primaryContrast : string;
    primaryBorder : string;
    primaryHover : string;
    primaryHoverContrast : string;
    primaryHoverBorder : string;
    secondary : string;
    secondaryContrast : string;
    secondaryBorder : string;
    secondaryHover : string;
    secondaryHoverContrast : string;
    secondaryHoverBorder : string;
    background : string;
    backgroundSecondary : string;
    backgroundContent : string;
    textColor : string;
    textColorLink : string;

    constructor() 
    {
    	            this.primary = "" ;
                this.primaryContrast = "" ;
                this.primaryBorder = "" ;
                this.primaryHover = "" ;
                this.primaryHoverContrast = "" ;
                this.primaryHoverBorder = "" ;
                this.secondary = "" ;
                this.secondaryContrast = "" ;
                this.secondaryBorder = "" ;
                this.secondaryHover = "" ;
                this.secondaryHoverContrast = "" ;
                this.secondaryHoverBorder = "" ;
                this.background = "" ;
                this.backgroundSecondary = "" ;
                this.backgroundContent = "" ;
                this.textColor = "" ;
                this.textColorLink = "" ;
        }
}

export class ProjectConfig extends BaseEntity {
    dashboardModules : string[];
    smtpMailConfig : SmtpMail;
    projectColors : ProjectColors;
    urlConfig : UrlConfig;
    skebbySmsSender : SkebbySmsSender;
    ticketTimeTable : TicketTimeTable;
    dietTypes : string[];
    leadStatuses : string[];
    leadSubStatuses : string[];
    frontendModules : FrontendModuleConfig[];
    showNews : boolean;
    paymentRequestConfig : PaymentRequestConfig;
    countryConfigList : CountryConfig[];
    paymentConfigDetails : PaymentConfigDetails;
    amazonS3Config : AmazonS3Config;
    charityAmount : number;

    constructor() 
    {
    	        super();
		            this.dashboardModules = [];
                this.smtpMailConfig = new SmtpMail();
                this.projectColors = new ProjectColors();
                this.urlConfig = new UrlConfig();
                this.skebbySmsSender = new SkebbySmsSender();
                this.ticketTimeTable = new TicketTimeTable();
                this.dietTypes = [];
                this.leadStatuses = [];
                this.leadSubStatuses = [];
                this.frontendModules = [];
                this.showNews = false ;
                this.paymentRequestConfig = new PaymentRequestConfig();
                this.countryConfigList = [];
                this.paymentConfigDetails = new PaymentConfigDetails();
                this.amazonS3Config = new AmazonS3Config();
                this.charityAmount = null ;
        }
}

export class SmtpMail {
    server : string;
    port : number;
    enableSsl : boolean;
    username : string;
    password : string;
    defaultSenderEmail : string;
    defaultSenderName : string;

    constructor() 
    {
    	            this.server = "" ;
                this.port = null ;
                this.enableSsl = false ;
                this.username = "" ;
                this.password = "" ;
                this.defaultSenderEmail = "" ;
                this.defaultSenderName = "" ;
        }
}

export class UrlConfig {
    logoUrl : string;
    playStoreUrl : string;
    appStoreUrl : string;
    appGalleryUrl : string;
    apiUrl : string;
    websocketUrl : string;
    webAppUrl : string;
    backofficeUrl : string;
    siteUrl : string;

    constructor() 
    {
    	            this.logoUrl = "" ;
                this.playStoreUrl = "" ;
                this.appStoreUrl = "" ;
                this.appGalleryUrl = "" ;
                this.apiUrl = "" ;
                this.websocketUrl = "" ;
                this.webAppUrl = "" ;
                this.backofficeUrl = "" ;
                this.siteUrl = "" ;
        }
}

export class SkebbySmsSender {
    username : string;
    password : string;
    sender : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
                this.sender = "" ;
        }
}

export class TicketTimeTable {
    userAssigned : NameIdentifier;
    firstMessageAfterTicket : LocalizedValue;
    textWhenClosed : LocalizedValue;
    times : TicketTimeTableTimes[];

    constructor() 
    {
    	            this.userAssigned = new NameIdentifier();
                this.firstMessageAfterTicket = new LocalizedValue();
                this.textWhenClosed = new LocalizedValue();
                this.times = [];
        }
}

export class TicketTimeTableTimes {
    day : DayOfWeek;
    startTime : string;
    endTime : string;

    constructor() 
    {
    	            this.day = null;
                this.startTime = "" ;
                this.endTime = "" ;
        }
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class PaymentRequestConfig {
    dayFrom : number;
    dayTo : number;
    minimumPayment : number;
    ritenutaPercentage : number;
    timePeriod : string;
    dayOfWeekFrom : DayOfWeek;
    dayOfWeekTo : DayOfWeek;
    paymentRequestMethods : PaymentRequestMethodDetails[];

    constructor() 
    {
    	            this.dayFrom = null ;
                this.dayTo = null ;
                this.minimumPayment = null ;
                this.ritenutaPercentage = null ;
                this.timePeriod = "" ;
                this.dayOfWeekFrom = null;
                this.dayOfWeekTo = null;
                this.paymentRequestMethods = [];
        }
}

export class PaymentRequestMethodDetails {
    name : string;
    methodType : string;

    constructor() 
    {
    	            this.name = "" ;
                this.methodType = "" ;
        }
}

export class CountryConfig {
    name : string;
    alpha2Code : string;
    callingCode : string;
    currency : string;
    userRicezioneLead : NameIdentifier;
    shippingCostConfig : ShippingCostConfig;

    constructor() 
    {
    	            this.name = "" ;
                this.alpha2Code = "" ;
                this.callingCode = "" ;
                this.currency = "" ;
                this.userRicezioneLead = new NameIdentifier();
                this.shippingCostConfig = new ShippingCostConfig();
        }
}

export class ShippingCostConfig {
    amountForFreeShipping : number;
    priceConfig : PriceConfig;

    constructor() 
    {
    	            this.amountForFreeShipping = null ;
                this.priceConfig = new PriceConfig();
        }
}

export class PriceConfig {
    grossAmount : number;
    vatPerc : number;
    points : number;

    constructor() 
    {
    	            this.grossAmount = null ;
                this.vatPerc = null ;
                this.points = null ;
        }
}

export class PaymentConfigDetails {
    paymentMethodsAllowed : PaymentMethodDetails[];
    bonificoConfigDetails : BonificoConfigDetails;
    cryptoPaymentInstructions : string;
    stripeConfigDetails : StripeConfigDetails;
    projectCode : string;
    currencyCode : string;
    currencySymbol : string;
    receiptFooter : string;
    needsFiscalCode : boolean;

    constructor() 
    {
    	            this.paymentMethodsAllowed = [];
                this.bonificoConfigDetails = new BonificoConfigDetails();
                this.cryptoPaymentInstructions = "" ;
                this.stripeConfigDetails = new StripeConfigDetails();
                this.projectCode = "" ;
                this.currencyCode = "" ;
                this.currencySymbol = "" ;
                this.receiptFooter = "" ;
                this.needsFiscalCode = false ;
        }
}

export class PaymentMethodDetails {
    name : string;
    title : LocalizedValue;
    description : LocalizedValue;
    methodType : string;
    priceMultiplier : number;
    currencySymbol : string;
    linkedEmailTemplate : string;

    constructor() 
    {
    	            this.name = "" ;
                this.title = new LocalizedValue();
                this.description = new LocalizedValue();
                this.methodType = "" ;
                this.priceMultiplier = null ;
                this.currencySymbol = "" ;
                this.linkedEmailTemplate = "" ;
        }
}

export class BonificoConfigDetails {
    bankDetails : string;

    constructor() 
    {
    	            this.bankDetails = "" ;
        }
}

export class StripeConfigDetails {
    stripePublicKey : string;
    stripeSecretKey : string;
    webhookSecret : string;
    paymentSuccessUrl : string;

    constructor() 
    {
    	            this.stripePublicKey = "" ;
                this.stripeSecretKey = "" ;
                this.webhookSecret = "" ;
                this.paymentSuccessUrl = "" ;
        }
}

export class AmazonS3Config {
    region : string;
    bucket : string;
    rootFolder : string;

    constructor() 
    {
    	            this.region = "" ;
                this.bucket = "" ;
                this.rootFolder = "" ;
        }
}

export class ProjectColorsPair {
    name : string;
    colors : ProjectColors;

    constructor() 
    {
    	            this.name = "" ;
                this.colors = new ProjectColors();
        }
}

export class PaymentConfigVm {
    stripePublicKey : string;
    currencySymbol : string;

    constructor() 
    {
    	            this.stripePublicKey = "" ;
                this.currencySymbol = "" ;
        }
}

export class CanRequestPaymentVm {
    pagamentoRequestConfig : PaymentRequestConfig;
    canRequest : boolean;

    constructor() 
    {
    	            this.pagamentoRequestConfig = new PaymentRequestConfig();
                this.canRequest = false ;
        }
}

export class PrefixCountry {
    country : string;
    prefix : string;

    constructor() 
    {
    	            this.country = "" ;
                this.prefix = "" ;
        }
}

export class SwaggerModelFiller {
    backendNotificationsAssenzaCliente : AssenzaCliente;
    backendNotificationsGeneric : GenericBackend;
    backendNotificationsMessaggioInPrenotazione : MessaggioInPrenotazione;
    backendNotificationsPrenotazioneRicevuta : PrenotazioneRicevuta;
    backendNotificationsTicketRicevuto : TicketRicevuto;
    commentoSuCliente : CommentoSuCliente;
    notaSuCliente : NotaSuCliente;
    baseWalletTransaction : BaseWalletTransaction;
    walletCharityDonation : WalletCharityDonation;
    walletCommissionPayment : WalletCommissionPayment;
    walletFirstTimeQualificationBonus : WalletFirstTimeQualificationBonus;
    walletManualBonus : WalletManualBonus;
    walletMoneyTransfer : WalletMoneyTransfer;
    walletPurchase : WalletPurchase;
    walletUserWithdraw : WalletUserWithdraw;
    inAppNotificationsAssenzaTreGiorni : AssenzaTreGiorni;
    shopProductsBookingVoucherProduct : BookingVoucherProduct;
    shopProductsCardProduct : CardProduct;
    shopProductsMembershipProduct : MembershipProduct;
    shopProductsSwapFundActivationProduct : SwapFundActivationProduct;
    shopProductsSwapFundExtensionProduct : SwapFundExtensionProduct;
    shopProductsPhysical : PhysicalProduct;
    pammProduct : PammProduct;
    pammVoucherProduct : PammVoucherProduct;
    purchaseDeferredPayment : PurchaseDeferredPayment;
    cardTopUp : CardTopUp;
    wallesterKeysConfig : WallesterKeysConfig;

    constructor() 
    {
    	            this.backendNotificationsAssenzaCliente = new AssenzaCliente();
                this.backendNotificationsGeneric = new GenericBackend();
                this.backendNotificationsMessaggioInPrenotazione = new MessaggioInPrenotazione();
                this.backendNotificationsPrenotazioneRicevuta = new PrenotazioneRicevuta();
                this.backendNotificationsTicketRicevuto = new TicketRicevuto();
                this.commentoSuCliente = new CommentoSuCliente();
                this.notaSuCliente = new NotaSuCliente();
                this.baseWalletTransaction = new BaseWalletTransaction();
                this.walletCharityDonation = new WalletCharityDonation();
                this.walletCommissionPayment = new WalletCommissionPayment();
                this.walletFirstTimeQualificationBonus = new WalletFirstTimeQualificationBonus();
                this.walletManualBonus = new WalletManualBonus();
                this.walletMoneyTransfer = new WalletMoneyTransfer();
                this.walletPurchase = new WalletPurchase();
                this.walletUserWithdraw = new WalletUserWithdraw();
                this.inAppNotificationsAssenzaTreGiorni = new AssenzaTreGiorni();
                this.shopProductsBookingVoucherProduct = new BookingVoucherProduct();
                this.shopProductsCardProduct = new CardProduct();
                this.shopProductsMembershipProduct = new MembershipProduct();
                this.shopProductsSwapFundActivationProduct = new SwapFundActivationProduct();
                this.shopProductsSwapFundExtensionProduct = new SwapFundExtensionProduct();
                this.shopProductsPhysical = new PhysicalProduct();
                this.pammProduct = new PammProduct();
                this.pammVoucherProduct = new PammVoucherProduct();
                this.purchaseDeferredPayment = new PurchaseDeferredPayment();
                this.cardTopUp = new CardTopUp();
                this.wallesterKeysConfig = new WallesterKeysConfig();
        }
}

export class AssenzaCliente extends BaseBackendNotification {
    cliente : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.cliente = new NameIdentifier();
        }
}

export class GenericBackend extends BaseBackendNotification {

    constructor() 
    {
    	        super();
		    }
}

export class MessaggioInPrenotazione extends BaseBackendNotification {
    prenotazioneIdentifier : string;
    cliente : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.prenotazioneIdentifier = "" ;
                this.cliente = new NameIdentifier();
        }
}

export class PrenotazioneRicevuta extends BaseBackendNotification {
    prenotazioneIdentifier : string;
    cliente : NameIdentifier;
    dottore : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.prenotazioneIdentifier = "" ;
                this.cliente = new NameIdentifier();
                this.dottore = new NameIdentifier();
        }
}

export class TicketRicevuto extends BaseBackendNotification {
    ticket : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.ticket = new NameIdentifier();
        }
}

export class CommentoSuCliente extends BaseBackendNotification {
    author : NameIdentifier;
    cliente : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.author = new NameIdentifier();
                this.cliente = new NameIdentifier();
        }
}

export class NotaSuCliente extends BaseBackendNotification {
    author : NameIdentifier;
    cliente : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.author = new NameIdentifier();
                this.cliente = new NameIdentifier();
        }
}

export class BaseWalletTransaction extends BaseEntity {
    user : NameIdentifier;
    date : string ;
    amount : number;
    note : string;
    type : string;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.date = null;
                this.amount = null ;
                this.note = "" ;
                this.type = "" ;
        }
}

export class WalletCharityDonation extends BaseWalletTransaction {
    receiptNumber : string;
    userPaymentRequestIdentifier : string;

    constructor() 
    {
    	        super();
		            this.receiptNumber = "" ;
                this.userPaymentRequestIdentifier = "" ;
        }
}

export class WalletCommissionPayment extends BaseWalletTransaction {
    commissionsDate : string ;
    commissionsIds : string[];

    constructor() 
    {
    	        super();
		            this.commissionsDate = null;
                this.commissionsIds = [];
        }
}

export class WalletFirstTimeQualificationBonus extends BaseWalletTransaction {
    qualificationCode : string;

    constructor() 
    {
    	        super();
		            this.qualificationCode = "" ;
        }
}

export class WalletManualBonus extends BaseWalletTransaction {

    constructor() 
    {
    	        super();
		    }
}

export class WalletMoneyTransfer extends BaseWalletTransaction {
    sentTo : NameIdentifier;
    receivedFrom : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.sentTo = new NameIdentifier();
                this.receivedFrom = new NameIdentifier();
        }
}

export class WalletPurchase extends BaseWalletTransaction {
    purchaseIdentifier : string;

    constructor() 
    {
    	        super();
		            this.purchaseIdentifier = "" ;
        }
}

export class WalletUserWithdraw extends BaseWalletTransaction {
    receiptNumber : string;
    userPaymentRequestIdentifier : string;

    constructor() 
    {
    	        super();
		            this.receiptNumber = "" ;
                this.userPaymentRequestIdentifier = "" ;
        }
}

export class AssenzaTreGiorni extends InAppNotification {

    constructor() 
    {
    	        super();
		    }
}

export class BaseProduct extends BaseEntity {
    name : string;
    title : LocalizedValue;
    subTitle : LocalizedValue;
    type : string;
    displayOrder : number;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.title = new LocalizedValue();
                this.subTitle = new LocalizedValue();
                this.type = "" ;
                this.displayOrder = null ;
        }
}

export class BookingVoucherProduct extends BaseProduct {
    pointsForDoctor : number;
    amountOfVoucher : number;
    profession : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.pointsForDoctor = null ;
                this.amountOfVoucher = null ;
                this.profession = new NameIdentifier();
        }
}

export class CardProduct extends BaseProduct {

    constructor() 
    {
    	        super();
		    }
}

export class MembershipProduct extends BaseProduct {

    constructor() 
    {
    	        super();
		    }
}

export class SwapFundActivationProduct extends BaseProduct {
    licenseType : string;
    maximumDeposit : number;

    constructor() 
    {
    	        super();
		            this.licenseType = "" ;
                this.maximumDeposit = null ;
        }
}

export class SwapFundExtensionProduct extends BaseProduct {

    constructor() 
    {
    	        super();
		    }
}

export class PhysicalProduct extends BaseProduct {

    constructor() 
    {
    	        super();
		    }
}

export class PammProduct extends BaseProduct {
    linkedPamm : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.linkedPamm = new NameIdentifier();
        }
}

export class PammVoucherProduct extends BaseProduct {
    amountOfVoucher : number;
    pammTier : number;

    constructor() 
    {
    	        super();
		            this.amountOfVoucher = null ;
                this.pammTier = null ;
        }
}

export class PurchaseDeferredPayment extends DeferredPayment {
    savedShoppingCart : ShoppingCart;

    constructor() 
    {
    	        super();
		            this.savedShoppingCart = new ShoppingCart();
        }
}

export class WallesterKeysConfig extends BaseEntity {
    projectConfigIdentifier : string;
    apiKey : string;
    publicKeyPath : string;
    privateKeyPath : string;

    constructor() 
    {
    	        super();
		            this.projectConfigIdentifier = "" ;
                this.apiKey = "" ;
                this.publicKeyPath = "" ;
                this.privateKeyPath = "" ;
        }
}

export class Purchase extends BaseEntity {
    customer : NameIdentifier;
    networkNode : NameIdentifier;
    purchasedOffers : PurchasedOffer[];
    paidAmount : number;
    paidCurrencySymbol : string;
    trackingNumber : string;
    number : string;
    shippingAddress : Address;
    fiscalData : FiscalData;
    status : string;
    statusHistory : DateValueOfString[];
    shippingCost : number;
    charityAmount : number;
    hiddenToCustomer : boolean;
    lavorato : boolean;
    paymentType : string;
    formAnswers : { [key: string]: string[]; };
    stripePaymentIntentId : string;
    totalGrossAmount : number;
    totalPoints : number;

    constructor() 
    {
    	        super();
		            this.customer = new NameIdentifier();
                this.networkNode = new NameIdentifier();
                this.purchasedOffers = [];
                this.paidAmount = null ;
                this.paidCurrencySymbol = "" ;
                this.trackingNumber = "" ;
                this.number = "" ;
                this.shippingAddress = new Address();
                this.fiscalData = new FiscalData();
                this.status = "" ;
                this.statusHistory = [];
                this.shippingCost = null ;
                this.charityAmount = null ;
                this.hiddenToCustomer = false ;
                this.lavorato = false ;
                this.paymentType = "" ;
                this.formAnswers = {};
                this.stripePaymentIntentId = "" ;
                this.totalGrossAmount = null ;
                this.totalPoints = null ;
        }
}

export class PurchasedOffer {
    identifier : string;
    imageUrl : string;
    name : string;
    displayName : LocalizedValue;
    subTitle : LocalizedValue;
    priceEntry : PriceConfig;
    points : number;
    quantity : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.imageUrl = "" ;
                this.name = "" ;
                this.displayName = new LocalizedValue();
                this.subTitle = new LocalizedValue();
                this.priceEntry = new PriceConfig();
                this.points = null ;
                this.quantity = null ;
        }
}

export class DateValueOfString {
    date : string ;
    value : string;

    constructor() 
    {
    	            this.date = null;
                this.value = "" ;
        }
}

export class MakePurchaseManuallyVm {
    hiddenToCustomer : boolean;
    cart : ShoppingCart;

    constructor() 
    {
    	            this.hiddenToCustomer = false ;
                this.cart = new ShoppingCart();
        }
}

export class TablePagedResultOfPurchase {
    data : Purchase[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PurchaseListFilterVm extends BasePagedRequest {
    fromDate : string ;
    toDate : string ;
    country : string;
    project : string;
    customer : string;
    networkNode : string;
    offers : string;
    trackingNumber : string;
    number : string;
    shippingAddress : string;
    status : string;
    hiddenToCustomer : boolean;
    lavorato : boolean;
    paymentType : string;
    points : string;

    constructor() 
    {
    	        super();
		            this.fromDate = null;
                this.toDate = null;
                this.country = "" ;
                this.project = "" ;
                this.customer = "" ;
                this.networkNode = "" ;
                this.offers = "" ;
                this.trackingNumber = "" ;
                this.number = "" ;
                this.shippingAddress = "" ;
                this.status = "" ;
                this.hiddenToCustomer = false ;
                this.lavorato = false ;
                this.paymentType = "" ;
                this.points = "" ;
        }
}

export class QualificationConfig extends BaseEntity {
    qualificationCode : string;
    order : number;
    euroPerPoint : number;
    manual : boolean;
    isBaseQualification : boolean;
    volumePointsRequired : number;
    firstLineRequirements : QualificationConfigFirstLineRequirement[];
    directReferralPurchasesRequired : number;
    profitPercentage : number;
    commissionRebate : number;
    swapProfitShare : number;
    poolShare : number;

    constructor() 
    {
    	        super();
		            this.qualificationCode = "" ;
                this.order = null ;
                this.euroPerPoint = null ;
                this.manual = false ;
                this.isBaseQualification = false ;
                this.volumePointsRequired = null ;
                this.firstLineRequirements = [];
                this.directReferralPurchasesRequired = null ;
                this.profitPercentage = null ;
                this.commissionRebate = null ;
                this.swapProfitShare = null ;
                this.poolShare = null ;
        }
}

export class QualificationConfigFirstLineRequirement {
    quantity : number;
    qualificationCode : string;

    constructor() 
    {
    	            this.quantity = null ;
                this.qualificationCode = "" ;
        }
}

export class RicettarioNode extends BaseEntity {
    nodeText : LocalizedValue;
    answersList : FaqNodeText[];

    constructor() 
    {
    	        super();
		            this.nodeText = new LocalizedValue();
                this.answersList = [];
        }
}

export class SmsEventDefinition {
    eventName : string;
    variables : string[];

    constructor() 
    {
    	            this.eventName = "" ;
                this.variables = [];
        }
}

export class TablePagedResultOfSmsSentLog {
    data : SmsSentLog[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class SmsSentLog extends BaseEntity {
    eventName : string;
    recipient : string;
    variables : { [key: string]: any; };

    constructor() 
    {
    	        super();
		            this.eventName = "" ;
                this.recipient = "" ;
                this.variables = {};
        }
}

export class SmsSentLogListFilterVm extends BasePagedRequest {
    createdOn : string ;
    country : string;
    project : string;
    recipient : string;
    eventName : string;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.country = "" ;
                this.project = "" ;
                this.recipient = "" ;
                this.eventName = "" ;
        }
}

export class StripeClientPaymentConfig {
    merchantDisplayName : string;
    publishableKey : string;
    customerId : string;
    paymentIntentId : string;
    clientSecret : string;
    ephemeralKey : string;

    constructor() 
    {
    	            this.merchantDisplayName = "" ;
                this.publishableKey = "" ;
                this.customerId = "" ;
                this.paymentIntentId = "" ;
                this.clientSecret = "" ;
                this.ephemeralKey = "" ;
        }
}

export class CreateClientPaymentConfigForCartRequestVm {
    cart : ShoppingCart;
    userIdentifier : string;

    constructor() 
    {
    	            this.cart = new ShoppingCart();
                this.userIdentifier = "" ;
        }
}

export class VideoDellaSettimana extends BaseEntity {
    name : string;
    title : LocalizedValue;
    description : LocalizedValue;
    user : NameIdentifier;
    url : string;
    attachment : Attachment;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.title = new LocalizedValue();
                this.description = new LocalizedValue();
                this.user = new NameIdentifier();
                this.url = "" ;
                this.attachment = new Attachment();
        }
}

export class CreateMoneyTransferVm {
    fromUser : string;
    toUser : NameIdentifier;
    importo : number;
    note : string;

    constructor() 
    {
    	            this.fromUser = "" ;
                this.toUser = new NameIdentifier();
                this.importo = null ;
                this.note = "" ;
        }
}

export class TablePagedResultOfBaseWalletTransaction {
    data : BaseWalletTransaction[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class WalletTransactionsListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    dateFrom : string ;
    dateTo : string ;
    user : string;
    amountFrom : number;
    amountTo : number;
    note : string;
    type : string;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.dateFrom = null;
                this.dateTo = null;
                this.user = "" ;
                this.amountFrom = null ;
                this.amountTo = null ;
                this.note = "" ;
                this.type = "" ;
        }
}

export class UpdateSwapFundDetailVm {
    customerIdentifier : string;
    brokerBalanceFP : number;
    brokerBalanceB : number;
    accountNumberFP : string;
    accountNumberB : string;

    constructor() 
    {
    	            this.customerIdentifier = "" ;
                this.brokerBalanceFP = null ;
                this.brokerBalanceB = null ;
                this.accountNumberFP = "" ;
                this.accountNumberB = "" ;
        }
}

export class SwapFund extends BaseEntity {
    customer : NameIdentifier;
    licenseType : string;
    maximumDeposit : number;
    brokerBalanceFP : number;
    brokerBalanceB : number;
    accountNumberFP : string;
    accountNumberB : string;
    expiresOn : string ;
    deletedOn : string ;

    constructor() 
    {
    	        super();
		            this.customer = new NameIdentifier();
                this.licenseType = "" ;
                this.maximumDeposit = null ;
                this.brokerBalanceFP = null ;
                this.brokerBalanceB = null ;
                this.accountNumberFP = "" ;
                this.accountNumberB = "" ;
                this.expiresOn = null;
                this.deletedOn = null;
        }
}

export class SwapFundUserBalanceVm {
    customer : NameIdentifier;
    totalBalance : number;

    constructor() 
    {
    	            this.customer = new NameIdentifier();
                this.totalBalance = null ;
        }
}

export class TablePagedResultOfRebatesRow {
    data : RebatesRow[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class RebatesRow extends BaseEntity {
    numericId : number;
    investmentId : string;
    amount : number;

    constructor() 
    {
    	        super();
		            this.numericId = null ;
                this.investmentId = "" ;
                this.amount = null ;
        }
}

export class RebateRowsListFilterVm extends BasePagedRequest {
    fromDate : string ;
    toDate : string ;
    numericId : number;
    investmentId : string;
    amount : number;

    constructor() 
    {
    	        super();
		            this.fromDate = null;
                this.toDate = null;
                this.numericId = null ;
                this.investmentId = "" ;
                this.amount = null ;
        }
}

export class CourseProduct extends BaseProduct {
    courseContents : CourseContent[];

    constructor() 
    {
    	        super();
		            this.courseContents = [];
        }
}

export class ProductCourseVm {
    createdOn : string ;
    displayOrder : number;
    identifier : string;
    title : LocalizedValue;
    subTitle : LocalizedValue;

    constructor() 
    {
    	            this.createdOn = null;
                this.displayOrder = null ;
                this.identifier = "" ;
                this.title = new LocalizedValue();
                this.subTitle = new LocalizedValue();
        }
}

export class ShopCategory extends BaseEntity {
    name : string;
    disabled : boolean;
    title : LocalizedValue;
    order : number;
    minProductLevelRequired : number;
    maxProductLevelRequired : number;
    useOfferRequirements : boolean;
    isUpsellCategory : boolean;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.disabled = false ;
                this.title = new LocalizedValue();
                this.order = null ;
                this.minProductLevelRequired = null ;
                this.maxProductLevelRequired = null ;
                this.useOfferRequirements = false ;
                this.isUpsellCategory = false ;
        }
}

export class LocalizedNameIdentifier {
    identifier : string;
    name : LocalizedValue;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = new LocalizedValue();
        }
}

export class ShopOffer extends BaseEntity {
    name : string;
    title : LocalizedValue;
    subTitle : LocalizedValue;
    categories : NameIdentifier[];
    products : NameIdentifier[];
    priceConfig : PriceConfig;
    imgUrl : string;
    displayOrder : number;
    rolesFilter : string[];
    disabled : boolean;
    charityAmount : number;
    minProductLevelRequired : number;
    maxProductLevelRequired : number;
    applyProductLevel : boolean;
    productLevelApplied : number;
    upsellOffers : NameIdentifier[];
    bonusPayments : BonusPaymentLevel[];
    appleIapId : string;
    repurchasable : boolean;
    productsRequiredForVisibility : NameIdentifier[];
    useBuyForm : boolean;
    formItems : FormItemConfig[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.title = new LocalizedValue();
                this.subTitle = new LocalizedValue();
                this.categories = [];
                this.products = [];
                this.priceConfig = new PriceConfig();
                this.imgUrl = "" ;
                this.displayOrder = null ;
                this.rolesFilter = [];
                this.disabled = false ;
                this.charityAmount = null ;
                this.minProductLevelRequired = null ;
                this.maxProductLevelRequired = null ;
                this.applyProductLevel = false ;
                this.productLevelApplied = null ;
                this.upsellOffers = [];
                this.bonusPayments = [];
                this.appleIapId = "" ;
                this.repurchasable = false ;
                this.productsRequiredForVisibility = [];
                this.useBuyForm = false ;
                this.formItems = [];
        }
}

export class BonusPaymentLevel {
    level : number;
    paymentAmount : number;

    constructor() 
    {
    	            this.level = null ;
                this.paymentAmount = null ;
        }
}

export class FormItemConfig {
    name : string;
    label : LocalizedValue;
    required : boolean;
    isSelect : boolean;
    isMultiSelect : boolean;
    options : LocalizedValue[];

    constructor() 
    {
    	            this.name = "" ;
                this.label = new LocalizedValue();
                this.required = false ;
                this.isSelect = false ;
                this.isMultiSelect = false ;
                this.options = [];
        }
}

export class PammConfig extends BaseEntity {
    nome : string;
    order : number;
    link : string;
    totale : string;
    hidden : boolean;
    tier : number;

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.order = null ;
                this.link = "" ;
                this.totale = "" ;
                this.hidden = false ;
                this.tier = null ;
        }
}

export class TablePagedResultOfPerformanceRow {
    data : PerformanceRow[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PerformanceRow extends BaseEntity {
    numericId : number;
    investmentId : string;
    investorName : string;
    amount : number;
    currency : string;
    time : string;

    constructor() 
    {
    	        super();
		            this.numericId = null ;
                this.investmentId = "" ;
                this.investorName = "" ;
                this.amount = null ;
                this.currency = "" ;
                this.time = "" ;
        }
}

export class PerformanceRowsListFilterVm extends BasePagedRequest {
    fromDate : string ;
    toDate : string ;
    numericId : number;
    investmentId : string;
    investorName : string;
    amount : number;

    constructor() 
    {
    	        super();
		            this.fromDate = null;
                this.toDate = null;
                this.numericId = null ;
                this.investmentId = "" ;
                this.investorName = "" ;
                this.amount = null ;
        }
}

export class UpdatePammDetailsVm {
    userIdentifier : string;
    pammDetails : PammDetails[];

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.pammDetails = [];
        }
}

export class PammDetails {
    firstActivationDate : string ;
    pamm : NameIdentifier;
    nomePamm : string;
    investmentId : string;
    saldo : number;

    constructor() 
    {
    	            this.firstActivationDate = null;
                this.pamm = new NameIdentifier();
                this.nomePamm = "" ;
                this.investmentId = "" ;
                this.saldo = null ;
        }
}

export class SubscribedPamm extends BaseEntity {
    user : NameIdentifier;
    pammDetails : PammDetails;
    expiresOn : string ;
    deletedOn : string ;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.pammDetails = new PammDetails();
                this.expiresOn = null;
                this.deletedOn = null;
        }
}

export class SaldoUserRowVm {
    name : string;
    userIdentifier : string;
    investmentId : string;
    amount : number;
    subscribedPamms : PammDetails[];

    constructor() 
    {
    	            this.name = "" ;
                this.userIdentifier = "" ;
                this.investmentId = "" ;
                this.amount = null ;
                this.subscribedPamms = [];
        }
}

export class InterpolationTemplate extends BaseEntity {
    subject : LocalizedValue2;
    text : LocalizedValue2;
    defaultLanguage : string;
    useRawHtmlEditor : boolean;
    eventName : string;
    additionalCc : string[];
    additionalBcc : string[];

    constructor() 
    {
    	        super();
		            this.subject = new LocalizedValue2();
                this.text = new LocalizedValue2();
                this.defaultLanguage = "" ;
                this.useRawHtmlEditor = false ;
                this.eventName = "" ;
                this.additionalCc = [];
                this.additionalBcc = [];
        }
}

export class LocalizedValue2 {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class SmsTemplate extends BaseEntity {
    text : LocalizedValue3;
    eventName : string;
    defaultLanguage : string;

    constructor() 
    {
    	        super();
		            this.text = new LocalizedValue3();
                this.eventName = "" ;
                this.defaultLanguage = "" ;
        }
}

export class LocalizedValue3 {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class TablePagedResultOfBaseVoucher {
    data : BaseVoucher[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BaseVoucher extends BaseEntity {
    purchaseIdentifier : string;
    product : NameIdentifier;
    customer : NameIdentifier;
    usedOn : string ;
    expiresOn : string ;
    pointsValue : number;
    type : string;

    constructor() 
    {
    	        super();
		            this.purchaseIdentifier = "" ;
                this.product = new NameIdentifier();
                this.customer = new NameIdentifier();
                this.usedOn = null;
                this.expiresOn = null;
                this.pointsValue = null ;
                this.type = "" ;
        }
}

export class VoucherListFilterVm extends BasePagedRequest {
    createdFrom : string ;
    createdTo : string ;
    cliente : string;
    product : string;
    usedFrom : string ;
    usedTo : string ;
    expiresOnFrom : string ;
    expiresOnTo : string ;

    constructor() 
    {
    	        super();
		            this.createdFrom = null;
                this.createdTo = null;
                this.cliente = "" ;
                this.product = "" ;
                this.usedFrom = null;
                this.usedTo = null;
                this.expiresOnFrom = null;
                this.expiresOnTo = null;
        }
}

export class FoodPlanVoucher extends BaseVoucher {
    foodPlanIdentifier : string;
    doctor : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.foodPlanIdentifier = "" ;
                this.doctor = new NameIdentifier();
        }
}

export class TablePagedResultOfBookingVoucher {
    data : BookingVoucher[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BookingVoucher extends BaseVoucher {
    doctor : NameIdentifier;
    profession : NameIdentifier;
    bookingIdentifier : string;

    constructor() 
    {
    	        super();
		            this.doctor = new NameIdentifier();
                this.profession = new NameIdentifier();
                this.bookingIdentifier = "" ;
        }
}

export class TablePagedResultOfPammVoucher {
    data : PammVoucher[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PammVoucher extends BaseVoucher {
    pammTier : number;
    subscribedPammIdentifier : string;

    constructor() 
    {
    	        super();
		            this.pammTier = null ;
                this.subscribedPammIdentifier = "" ;
        }
}

export class PammVoucherListFilterVm {
    pageNumber : number;
    perPage : number;
    createdOn : string ;
    fromDate : string ;
    toDate : string ;
    cliente : string;
    tier : number;
    usedFrom : string ;
    usedTo : string ;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.createdOn = null;
                this.fromDate = null;
                this.toDate = null;
                this.cliente = "" ;
                this.tier = null ;
                this.usedFrom = null;
                this.usedTo = null;
        }
}

export class BaseUser extends BaseEntity {
    personalData : PersonalData;
    contactData : ContactData;
    fiscalData : FiscalData;
    authData : AuthData;
    country : string;
    referralCode : string;
    gestioneAcceptedOn : string ;
    networkParentNode : NameIdentifier;
    networkParentNodeHistory : DateValueOfNodeAssignment[];
    preferredCulture : string;
    role : string;
    type : string;
    linkedAccounts : NameIdentifier[];
    lastLoginOn : string ;
    note : Comment[];
    comments : Comment[];
    statuses : Statuses;
    list : string;
    source : string;
    chiamato : string ;
    lavorato : boolean;
    qualifications : Qualification[];

    constructor() 
    {
    	        super();
		            this.personalData = new PersonalData();
                this.contactData = new ContactData();
                this.fiscalData = new FiscalData();
                this.authData = new AuthData();
                this.country = "" ;
                this.referralCode = "" ;
                this.gestioneAcceptedOn = null;
                this.networkParentNode = new NameIdentifier();
                this.networkParentNodeHistory = [];
                this.preferredCulture = "" ;
                this.role = "" ;
                this.type = "" ;
                this.linkedAccounts = [];
                this.lastLoginOn = null;
                this.note = [];
                this.comments = [];
                this.statuses = new Statuses();
                this.list = "" ;
                this.source = "" ;
                this.chiamato = null;
                this.lavorato = false ;
                this.qualifications = [];
        }
}

export class AuthData {
    username : string;
    password : string;
    tempPassword : string;
    tokenForResetPassword : string;
    passwordExpirationDate : string ;
    loginEnabled : boolean;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
                this.tempPassword = "" ;
                this.tokenForResetPassword = "" ;
                this.passwordExpirationDate = null;
                this.loginEnabled = false ;
        }
}

export class DateValueOfNodeAssignment {
    date : string ;
    value : NodeAssignment;

    constructor() 
    {
    	            this.date = null;
                this.value = new NodeAssignment();
        }
}

export class NodeAssignment {
    assigner : NameIdentifier;
    assigned : NameIdentifier;
    reason : string;

    constructor() 
    {
    	            this.assigner = new NameIdentifier();
                this.assigned = new NameIdentifier();
                this.reason = "" ;
        }
}

export class Statuses {
    status : string;
    statusHistory : DateValueOfStatusChange[];
    subStatus : string;
    subStatusHistory : DateValueOfStatusChange[];
    scadenze : ToDo[];
    productLevel : number;
    dietType : string;

    constructor() 
    {
    	            this.status = "" ;
                this.statusHistory = [];
                this.subStatus = "" ;
                this.subStatusHistory = [];
                this.scadenze = [];
                this.productLevel = null ;
                this.dietType = "" ;
        }
}

export class DateValueOfStatusChange {
    date : string ;
    value : StatusChange;

    constructor() 
    {
    	            this.date = null;
                this.value = new StatusChange();
        }
}

export class StatusChange {
    identifier : string;
    author : NameIdentifier;
    from : string;
    to : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.author = new NameIdentifier();
                this.from = "" ;
                this.to = "" ;
        }
}

export class ToDo {
    identifier : string;
    createdOn : string ;
    startDate : string ;
    endDate : string ;
    author : NameIdentifier;
    text : string;
    toDoType : string;
    attachments : Attachment[];
    status : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.startDate = null;
                this.endDate = null;
                this.author = new NameIdentifier();
                this.text = "" ;
                this.toDoType = "" ;
                this.attachments = [];
                this.status = "" ;
        }
}

export class AssignToVm {
    userIdentifier : string;
    assignTo : NameIdentifier;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.assignTo = new NameIdentifier();
        }
}

export class ActivateOfferOnMultipleCustomersVm {
    customerList : string[];
    shopOfferIdentifier : string;

    constructor() 
    {
    	            this.customerList = [];
                this.shopOfferIdentifier = "" ;
        }
}

export class TablePagedResultOfBaseUserTableVm {
    data : BaseUserTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class BaseUserTableVm {
    identifier : string;
    createdOn : string ;
    lastLoginOn : string ;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    networkParentNode : NameIdentifier;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.lastLoginOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.telephone = "" ;
                this.networkParentNode = new NameIdentifier();
        }
}

export class BaseUserListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    networkParentUser : string;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.createdOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.telephone = "" ;
                this.networkParentUser = "" ;
        }
}

export class Lead extends BaseUser {

    constructor() 
    {
    	        super();
		    }
}

export class Customer extends Lead {
    paymentData : UserPaymentData;

    constructor() 
    {
    	        super();
		            this.paymentData = new UserPaymentData();
        }
}

export class PaymentUser extends Customer {

    constructor() 
    {
    	        super();
		    }
}

export class Operator extends PaymentUser {
    obiettivoMensile : number;
    storicoObiettivoMensile : DateValueOfDecimal[];

    constructor() 
    {
    	        super();
		            this.obiettivoMensile = null ;
                this.storicoObiettivoMensile = [];
        }
}

export class LeadInAccettazioneResponseVm {
    tempoMedioAccettazione : number;
    pagedResult : TablePagedResultOfLeadInAccettazioneVm;

    constructor() 
    {
    	            this.tempoMedioAccettazione = null ;
                this.pagedResult = new TablePagedResultOfLeadInAccettazioneVm();
        }
}

export class TablePagedResultOfLeadInAccettazioneVm {
    data : LeadInAccettazioneVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class LeadInAccettazioneVm {
    identifier : string;
    createdOn : string ;
    acceptedOn : string ;
    lastAssignment : DateValueOfNodeAssignment;
    contactName : string;
    name : string;
    surname : string;
    networkParentNode : NameIdentifier;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.acceptedOn = null;
                this.lastAssignment = new DateValueOfNodeAssignment();
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.networkParentNode = new NameIdentifier();
        }
}

export class LeadInAccettazioneFilterVm extends BasePagedRequest {
    showAccepted : boolean;
    createdOn : string ;
    assignedOn : string ;
    acceptedOn : string ;
    contactName : string;
    acceptanceReason : string;
    name : string;
    surname : string;
    assignedTo : string;
    networkNode : string;

    constructor() 
    {
    	        super();
		            this.showAccepted = false ;
                this.createdOn = null;
                this.assignedOn = null;
                this.acceptedOn = null;
                this.contactName = "" ;
                this.acceptanceReason = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.assignedTo = "" ;
                this.networkNode = "" ;
        }
}

export class UpdateAddressVm {
    identifier : string;
    address : Address;

    constructor() 
    {
    	            this.identifier = "" ;
                this.address = new Address();
        }
}

export class UpdateLuogoDataNascitaVm {
    identifier : string;
    luogo : string;
    dataNascita : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.luogo = "" ;
                this.dataNascita = null;
        }
}

export class UpdatePersonalDataVm {
    identifier : string;
    data : PersonalData;

    constructor() 
    {
    	            this.identifier = "" ;
                this.data = new PersonalData();
        }
}

export class UpdateFiscalDataVm {
    identifier : string;
    data : FiscalData;

    constructor() 
    {
    	            this.identifier = "" ;
                this.data = new FiscalData();
        }
}

export class ResetPasswordVm {
    password : string;
    token : string;

    constructor() 
    {
    	            this.password = "" ;
                this.token = "" ;
        }
}

export class LeadAssignmentHistoryVm {
    lead : NameIdentifier;
    storicoAssegnazione : DateValueOfNodeAssignment;

    constructor() 
    {
    	            this.lead = new NameIdentifier();
                this.storicoAssegnazione = new DateValueOfNodeAssignment();
        }
}

export class MultipleLeadsActionVm {
    leadList : string[];
    userIdentifier : string;
    value : string;

    constructor() 
    {
    	            this.leadList = [];
                this.userIdentifier = "" ;
                this.value = "" ;
        }
}

export class CheckEmailVm {
    identifier : string;
    email : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.email = "" ;
        }
}

export class CheckNumberVm {
    identifier : string;
    telephone : Telephone;

    constructor() 
    {
    	            this.identifier = "" ;
                this.telephone = new Telephone();
        }
}

export class TablePagedResultOfCustomerTableVm {
    data : CustomerTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class CustomerTableVm {
    identifier : string;
    createdOn : string ;
    lastLoginOn : string ;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    status : string;
    subStatus : string;
    networkParentNode : NameIdentifier;
    scadenze : ToDo[];
    role : string;
    type : string;
    chiamato : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.lastLoginOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.telephone = "" ;
                this.status = "" ;
                this.subStatus = "" ;
                this.networkParentNode = new NameIdentifier();
                this.scadenze = [];
                this.role = "" ;
                this.type = "" ;
                this.chiamato = "" ;
        }
}

export class CustomerListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    showTelephoneOnly : boolean;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    telephone : string;
    email : string;
    networkParentUser : string;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.showTelephoneOnly = false ;
                this.createdOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.telephone = "" ;
                this.email = "" ;
                this.networkParentUser = "" ;
        }
}

export class TablePagedResultOfLeadTableVm {
    data : LeadTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class LeadTableVm {
    identifier : string;
    createdOn : string ;
    lastLoginOn : string ;
    type : string;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    status : string;
    subStatus : string;
    networkParentNode : NameIdentifier;
    scadenze : ToDo[];
    role : string;
    chiamato : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.lastLoginOn = null;
                this.type = "" ;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.telephone = "" ;
                this.status = "" ;
                this.subStatus = "" ;
                this.networkParentNode = new NameIdentifier();
                this.scadenze = [];
                this.role = "" ;
                this.chiamato = "" ;
        }
}

export class LeadListFilterVm extends BasePagedRequest {
    userIdentifier : string;
    selectedList : string;
    dottoreAssegnato : string;
    showLead : boolean;
    showCustomers : boolean;
    showCollaboratori : boolean;
    showTelephoneOnly : boolean;
    subStatusFilter : string;
    showInRitardoOnly : boolean;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    telephone : string;
    email : string;
    status : string;
    networkParentUser : string;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.selectedList = "" ;
                this.dottoreAssegnato = "" ;
                this.showLead = false ;
                this.showCustomers = false ;
                this.showCollaboratori = false ;
                this.showTelephoneOnly = false ;
                this.subStatusFilter = "" ;
                this.showInRitardoOnly = false ;
                this.createdOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.telephone = "" ;
                this.email = "" ;
                this.status = "" ;
                this.networkParentUser = "" ;
        }
}

export class LeadList extends BaseEntity {
    value : string;

    constructor() 
    {
    	        super();
		            this.value = "" ;
        }
}

export class CreateUserVm {
    name : string;
    surname : string;
    email : string;
    password : string;
    username : string;
    referralCode : string;
    loginEnabled : boolean;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.password = "" ;
                this.username = "" ;
                this.referralCode = "" ;
                this.loginEnabled = false ;
        }
}

export class ObiettivoMensileVm {
    obiettivoMensile : number;
    risultato : number;
    changesNextMonth : boolean;

    constructor() 
    {
    	            this.obiettivoMensile = null ;
                this.risultato = null ;
                this.changesNextMonth = false ;
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}